import { createFileRoute } from "@tanstack/react-router";
import { DestinationEditor } from "@/components/admin/DestinationEditor";
import { RouteErrorBoundary } from "@/lib/route-boundaries";

export const Route = createFileRoute("/admin/destinations/new")({
  head: () => ({
    meta: [
      { title: "Nuevo destino | Admin | Fora da Rota" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => <DestinationEditor />,
  errorComponent: RouteErrorBoundary,
});
